module.exports = __webpack_public_path__ + "img/2b08386.svg";